import { getEnvValue } from './getEnvValue';

export const FIREBASE_API_KEY = getEnvValue('FIREBASE_API_KEY');
export const FIREBASE_AUTH_DOMAIN = getEnvValue('FIREBASE_AUTH_DOMAIN');
export const FIREBASE_DATABASE_URL = getEnvValue('FIREBASE_DATABASE_URL');
export const FIREBASE_PROJECT_ID = getEnvValue('FIREBASE_PROJECT_ID');
export const FIREBASE_STORAGE_BUCKET = getEnvValue('FIREBASE_STORAGE_BUCKET');
export const FIREBASE_MESSAGING_SENDER_ID = getEnvValue(
  'FIREBASE_MESSAGING_SENDER_ID',
);
export const FIREBASE_APP_ID = getEnvValue('FIREBASE_APP_ID');
export const FIREBASE_MEASUREMENT_ID = getEnvValue('FIREBASE_MEASUREMENT_ID');
export const RETAIL_API_URL = getEnvValue('RETAIL_API_URL');
export const RETAIL_API_KEY = getEnvValue('RETAIL_API_KEY');
export const MOCKED_READER = getEnvValue('MOCKED_READER');
export const STATISTIC_API_BASE_URL = getEnvValue('STATISTIC_API_BASE_URL');
export const STATISTIC_API_KEY = getEnvValue('STATISTIC_API_KEY');
export const LOGDNA_API_KEY = getEnvValue('LOGDNA_API_KEY');

// logging
export const GOOGLE_CREDENTIALS_BASE64 = getEnvValue(
  'GOOGLE_CREDENTIALS_BASE64',
);
let DYNAMIC_UUID = 'TEST-TRACING-UUID';
if (crypto && typeof crypto.randomUUID === 'function') {
  DYNAMIC_UUID = crypto.randomUUID();
}
export const TRACING_UUID = DYNAMIC_UUID;
